'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dSignal from "./com.raquo.airstream.core.-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V($thiz) {
  $thiz.u2($j_com$002eraquo$002eairstream$002ecore$002e$002dSignal.$is_Lcom_raquo_airstream_core_Signal($thiz.eB()));
  $thiz.kJ((-1));
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V($thiz) {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz.eB());
  if ($thiz.rc()) {
    var newParentLastUpdateId = $thiz.eB().gs();
    if ((newParentLastUpdateId !== $thiz.tQ())) {
      $thiz.ll($thiz.id(), newParentLastUpdateId);
    }
  }
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V($thiz, nextValue, nextParentLastUpdateId) {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
  $thiz.kJ(nextParentLastUpdateId);
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextParentValue, transaction) {
  if ($thiz.rc()) {
    $thiz.kJ($thiz.eB().gs());
  }
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V($thiz) {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz.eB(), $thiz, false);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dSignal.$f_Lcom_raquo_airstream_core_Signal__onStart__V($thiz);
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V($thiz) {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz.eB(), $thiz);
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V };
